export default __webpack_public_path__ + "static/bg-image-2370c761455a21e0a57d4595a4536837.png";